"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinWithConjunction = exports.splitArray = exports.concatStringsIfTruthy = exports.setUuidFromIndex = exports.getDistinctArrayValues = exports.reduceToTruthyProperties = exports.alphaNumSort = exports.sortArrayByObjectKey = exports.firstOr = exports.toggleInclusion = exports.getValueByObjectKey = exports.replaceObjectOrConcat = exports.groupItemsByObjectProperty = exports.without = void 0;
const naturalCompare = require('natural-compare-lite');
function without(object, ...keys) {
    return Object.entries(object)
        .filter(([key]) => keys.indexOf(key) === -1)
        .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
    }, Object.create(null));
}
exports.without = without;
function groupItemsByObjectProperty(items, idKeyName) {
    let groupedItems = {};
    items.forEach(item => {
        const newItemObject = without(item, idKeyName);
        const id = Object.keys(groupedItems)
            .find(id => parseInt(id, 10) === item[idKeyName]);
        if (id) {
            const entireArray = groupedItems[id].concat([newItemObject]);
            groupedItems = { ...groupedItems, [id]: entireArray };
        }
        else {
            groupedItems = { ...groupedItems, [item[idKeyName]]: [newItemObject] };
        }
    });
    return groupedItems;
}
exports.groupItemsByObjectProperty = groupItemsByObjectProperty;
function replaceObjectOrConcat({ array, compareKey, object }) {
    let found = false;
    array = array.map(item => {
        if (item[compareKey] === object[compareKey]) {
            found = true;
            return object;
        }
        return item;
    });
    return found ? array : array.concat(object);
}
exports.replaceObjectOrConcat = replaceObjectOrConcat;
function getValueByObjectKey({ array, keyToMatch, matchValue, returnProperty }) {
    if (array && array.length > 0) {
        const found = array.find(item => item[keyToMatch] === matchValue);
        if (found) {
            return found[returnProperty];
        }
    }
}
exports.getValueByObjectKey = getValueByObjectKey;
function toggleInclusion(array, value) {
    if (array.find(item => item === value)) {
        return array.filter(item => item !== value);
    }
    else {
        return [...array, value];
    }
}
exports.toggleInclusion = toggleInclusion;
function firstOr(array, or = null) {
    if (Array.isArray(array) && array.length > 0) {
        return array[0];
    }
    return or;
}
exports.firstOr = firstOr;
function sortArrayByObjectKey({ array, key }) {
    return array.slice().sort((a, b) => {
        const nameA = typeof (a[key]) === 'string' ? a[key].toUpperCase() : a[key];
        const nameB = typeof (b[key]) === 'string' ? b[key].toUpperCase() : b[key];
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    });
}
exports.sortArrayByObjectKey = sortArrayByObjectKey;
function alphaNumSort(a, b, sortProp, sortDirection = 'ASC') {
    const compareResults = naturalCompare(a[sortProp], b[sortProp]);
    return sortDirection === 'ASC' ? compareResults : compareResults * -1;
}
exports.alphaNumSort = alphaNumSort;
function reduceToTruthyProperties({ array, key, returnFullObject = false, returnFalseIfEmpty = true }) {
    if (!Array.isArray(array)) {
        array = [];
    }
    const newArray = array.reduce((sum, item) => {
        const value = returnFullObject ? item : item[key];
        return item[key] ? sum.concat(value) : sum;
    }, []);
    return returnFalseIfEmpty && newArray.length === 0 ? false : newArray;
}
exports.reduceToTruthyProperties = reduceToTruthyProperties;
function getDistinctArrayValues(array) {
    return Array.from(new Set(array));
}
exports.getDistinctArrayValues = getDistinctArrayValues;
function setUuidFromIndex(array) {
    return array.map((item, index) => ({ ...item, uuid: index }));
}
exports.setUuidFromIndex = setUuidFromIndex;
function concatStringsIfTruthy({ array, separator = ' ' }) {
    if (array && Array.isArray(array) && array.length > 0 && array.every(val => typeof (val) === 'string')) {
        return array.filter(string => string).join(separator);
    }
    return '';
}
exports.concatStringsIfTruthy = concatStringsIfTruthy;
function splitArray({ array, test }) {
    let pass = [];
    let fail = [];
    array.forEach(item => {
        const passedTest = test(item);
        if (passedTest) {
            pass.push(item);
        }
        else {
            fail.push(item);
        }
    });
    return { pass, fail };
}
exports.splitArray = splitArray;
function joinWithConjunction(array, options = {}) {
    options = { separator: ', ', conjunction: '& ', oxfordComma: true, ...options };
    if (array.length === 0) {
        return '';
    }
    if (array.length === 1) {
        return array[0];
    }
    if (!options.conjunction) {
        return array.join(options.separator);
    }
    const beginning = array.slice(0, array.length - 1).join(options.separator);
    return `${beginning}${options.oxfordComma ? options.separator : ' '}${options.conjunction}${array[array.length - 1]}`;
}
exports.joinWithConjunction = joinWithConjunction;
//# sourceMappingURL=index.js.map